module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/home-front-service-lvl1-50.7243f6f2.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/home-front-service-lvl1-50.png
// module id = 3535
// module chunks = 11